import React, {
  memo, useCallback, useMemo, useState,
} from 'react'

import {
  FiltersSidebar, Button, Icon, Search,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import I18n from 'Pods/Shared/I18n'

import { FEATURES, DEFAULT_LIMIT } from './constants'

const translate = (key) => I18n.t(key, { ns: 'rails' })

function FeaturesContent() {
  const animated = useSearchPageStore(state => state.animated)
  const pbr = useSearchPageStore(state => state.pbr)
  const rigged = useSearchPageStore(state => state.rigged)
  const gameReady = useSearchPageStore(state => state.gameReady)
  const withRenders = useSearchPageStore(state => state.withRenders)
  const polygonRanges = useSearchPageStore(state => state.polygonRanges)
  const [showAll, setShowAll] = useState(false)

  // Single group, no sub-heading: the collapsible header already names the section "Features".
  const featuresConfig = useMemo(() => [{
    label: '',
    isSearchable: true,
    filters: FEATURES.map(({ value, labelKey }) => ({
      value,
      label: translate(`search_page.filters.${labelKey}`),
    })),
  }], [])

  const selectedFeatures = useMemo(() => {
    const state = { animated, pbr, rigged, gameReady, withRenders, polygonRanges }
    return FEATURES.filter(feature => feature.select(state)).map(feature => feature.value)
  }, [animated, pbr, rigged, gameReady, withRenders, polygonRanges])

  const handleChange = useCallback((_, value, isOn) => {
    const feature = FEATURES.find(item => item.value === value)
    feature?.onChange(isOn)
  }, [])

  const textInputProps = useMemo(() => ({
    leadIcon: <Icon notSpaced svgComponent={Search} color="dark" />,
    textInputClassName: 'filter-wrapper__search-input',
  }), [])

  // limit=0 tells FiltersGroup to show all items; toggling reveals the rest behind "Show more".
  const effectiveLimit = showAll ? 0 : DEFAULT_LIMIT
  const hasMore = FEATURES.length > DEFAULT_LIMIT

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={featuresConfig}
        selectedFilters={selectedFeatures}
        onFiltersChange={handleChange}
        limit={effectiveLimit}
        isControlled
        useNewCheckboxes
        hideShowMore
        hideLastDivider
        searchPlaceholder={translate('search_page.filters.features.search_placeholder')}
        textInputProps={textInputProps}
        baseFormWrapperClassName="filter-wrapper__content"
      />
      {hasMore && (
        <Button
          type="ghost-primary"
          size="small"
          customClass="filter-wrapper__show-more cgt-link-primary"
          onClick={() => setShowAll(value => !value)}
        >
          {translate(`search_page.filters.features.${showAll ? 'show_less' : 'show_more'}`)}
        </Button>
      )}
    </>
  )
}

export default memo(FeaturesContent)
